import { render } from "./RollGame.vue?vue&type=template&id=183eaece&scoped=true"
import script from "./RollGame.vue?vue&type=script&lang=js"
export * from "./RollGame.vue?vue&type=script&lang=js"

import "./RollGame.vue?vue&type=style&index=0&id=183eaece&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-183eaece"]])

export default __exports__